var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteL(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C9.44772 9 9 9.44772 9 10V16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16V10C11 9.44772 10.5523 9 10 9Z",
    fill: "#0043A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10V16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16V10Z",
    fill: "#0043A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C7.44772 2 7 2.44772 7 3V4H3C2.44772 4 2 4.44772 2 5C2 5.55228 2.44772 6 3 6H4V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V6H21C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4H17V3C17 2.44772 16.5523 2 16 2H8ZM17 20C17.5523 20 18 19.5523 18 19V6H6V19C6 19.5523 6.44771 20 7 20H17Z",
    fill: "#0043A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteL);
export default __webpack_public_path__ + "static/media/delete_l.fe96444c8b34bd53e297380b68c1d4e6.svg";
export { ForwardRef as ReactComponent };